import { Injectable, Inject } from '@angular/core';
// import * as Prism from 'prismjs';

import { Prism } from '../../../core/modules/prism/models/prism.model';
import { PRISM } from '../../../core/modules/prism/prism.config';

@Injectable({
  providedIn: 'root'
})
export class PrismService {

  private _prism: Prism;

  constructor(@Inject(PRISM) private prism: any) {
    this._prism = this.prism();
  }

  public highlight(code: string, lang: string): string {
    if (!lang) {
      return '';
    }
    const formattedHTML = this._prism.highlight(code, this._prism.languages[lang]);
    return formattedHTML;
  }
}
